import { useEffect, useRef } from "react";

import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "../../main.css";

export const FANCYBOX_DEFAULT_PROPS = {
  mainClass: "fancybox-overlay",
  width: 1500,
  enableRotation: true,
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: ["rotateCCW", "rotateCW"],
    },
  },
};

function Fancybox(props) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const delegate = props.delegate || "[data-fancybox]";

    NativeFancybox.bind(container, delegate, FANCYBOX_DEFAULT_PROPS);

    return () => {
      NativeFancybox.unbind(container);
      NativeFancybox.close();
    };
  }, []);

  return <div ref={containerRef}>{props.children}</div>;
}

export default Fancybox;
